import React from 'react'
import { Drawer as AntdDrawer } from 'antd'
import styled from 'styled-components'


const StyledDrawer = styled(AntdDrawer)`

  .ant-drawer-body {
    padding: ${props => (props.padding ? props.padding : '30px')};
    
  }
  .ant-drawer-wrapper-body {
    height: 100%;
    overflow: auto;
  }
  .ant-drawer-header-title {
    flex-direction: ${props =>
      props.closeIconPosition == 'right' ? 'row-reverse' : 'row'};
  }
`

const DrawerSkill = ({
  width = '40%',
  height,
  placement,
  closable = false,
  onClose,
  visible,
  content,
  footerStyles,
  closeIconPosition = 'right',
  padding,
  maskClosable=false,
  ...rest
}) => {
  return (
    <StyledDrawer
      {...rest}
      width={width}
      height={height}
      placement={placement}
      closable={closable}
      onClose={onClose}
      visible={visible}
      key={placement}
      closeIconPosition={closeIconPosition}
      padding={padding}
      maskClosable={maskClosable}
    >
      {content}

     
    </StyledDrawer>
  )
}
export default DrawerSkill
